import $api from '../services';

export default {
    getRefreshTime() {
        return $api.get('/refresh_period', {
            tab: 'portfolio',
        });
    },
    setRefreshTime(val) {
        return $api.get('/refresh_period', {
            tab: 'portfolio',
            period: val,
        });
    },
    getNewPosition() {
        return $api.get('/new_position');
    },
    setNewPosition(params) {
        return $api.get('/new_position', {
            default: params,
        });
    },
    getPortfolioFields() {
        return $api.get('/pull_list_config', {
            tab: 'portfolio_fields',
        });
    },
    updatePortfolioFields(params) {
        params = JSON.stringify(params);
        return $api.get('/update_list_config', {
            tab: 'portfolio_fields',
            config_body: params,
        });
    },
    getPortfolioWatchlist() {
        return $api.get('/pull_list_config', {
            tab: 'portfolio_watchlist',
        });
    },
    updatePortfolioWatchList(params) {
        params = JSON.stringify(params);
        return $api.get('/update_list_config', {
            tab: 'portfolio_watchlist',
            config_body: params,
        });
    },
};
